import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import  Item from './Item';
import './style.scss';

const selectOption = (props) => {
  const {title, items, active, withBorder, callback, colSize, id, label } = props;

  let className = "Select-Option";

  if(withBorder)
    className += ' with-border';

  if(!active)
    className += ' disabled';

  return (
    <div className={className}>
      <h6>
        <label htmlFor={id} className='mb-0'>
          {title}
        </label>
        {
          label.length > 0 &&
          <span className="iDEAL-Form-Badge badge badge-warning float-right">{label}</span>
        }
      </h6>
      <Row id={id}>
        {
          items.map((item, index) =>
            <Col md={6} sm={12} lg={colSize} className='selector-column mt-2' key={index}>
              <Item
                title={item.label}
                value={item.value}
                id={`${id}_${item.value}`}
                unit={item.unit}
                description={item.description}
                isActive={item.selected}
                disabled={item.disabled}
                callback={props.callback}
              />
            </Col>
        )}
      </Row>
    </div>
  );
};


selectOption.defaultProps = {
  id: '',
  subtitle: '',
  active: false,
  withBorder: true,
  colSize: 3,
  callback: () => {},
  label: '',
};

selectOption.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any.isRequired,
    unit: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    description: PropTypes.node
  })).isRequired,
  active: PropTypes.bool,
  withBorder: PropTypes.bool,
  colSize: PropTypes.number,
  callback: PropTypes.func,
  label: PropTypes.string
};

export default selectOption;
